import React from 'react';
import { Text, TextProps as _TextProps } from 'rebass/styled-components';

const base = {};

export const baseP = {
  ...base,
  fontSize: 16,
  fontWeight: 400,
};

export type TextProps = _TextProps;

/**
 * Styles used for paragraph-sized text elements.
 */
export const P = (props: TextProps) => (
  <Text
    as="p"
    {...props}
    sx={{
      color: 'gray70',
      ...baseP,
      ...base,
      ...(props.sx || {}),
    }}
  />
);

/**
 * Styles used for anchor elements.
 */
export const A = (props: TextProps) => (
  <Text
    as="a"
    {...props}
    sx={{
      fontSize: 16,
      fontWeight: 400,
      ...base,
      ...(props.sx || {}),
    }}
  />
);

/**
 * Styles used for h4-sized text elements.
 */
export const H4 = (props: TextProps) => (
  <Text
    as="h4"
    {...props}
    sx={{
      fontSize: 16,
      color: 'gray80',
      fontWeight: 700,
      ...base,
      ...(props.sx || {}),
    }}
  />
);

/**
 * Styles used for h3-sized text elements.
 */
export const H3 = (props: TextProps) => (
  <Text
    as="h3"
    {...props}
    sx={{
      fontSize: 18,
      color: 'gray80',
      fontWeight: 700,
      ...base,
      ...(props.sx || {}),
    }}
  />
);

/**
 * Styles used for h2-sized text elements.
 */
export const H2 = (props: TextProps) => (
  <Text
    as="h2"
    {...props}
    sx={{
      fontSize: 24,
      color: 'gray80',
      fontWeight: 700,
      ...base,
      ...(props.sx || {}),
    }}
  />
);

/**
 * Styles used for h1-sized text elements.
 */
export const H1 = (props: TextProps) => (
  <Text
    as="h1"
    {...props}
    sx={{
      fontSize: 32,
      color: 'gray90',
      fontWeight: 700,
      ...base,
      ...(props.sx || {}),
    }}
  />
);

export default Text;
